export class CommonHelper {
    public static bindDisablingSaveButton() {

        var forms = $('form');
        forms.each((index, formElement) => {
            var form = $(formElement);

            var submitButton = form.find(':submit');
            var submitButtonParent = submitButton?.parent();
            if(submitButtonParent.hasClass('btn-group')) {
                submitButtonParent = submitButtonParent.parent();
            }

            var formId = form.attr('id');
            var externalSubmitButton = $(`button[form=${formId}]`);
            var externalSubmitButtonParent = externalSubmitButton?.parent();
            if(externalSubmitButtonParent.hasClass('btn-group')) {
                externalSubmitButtonParent = externalSubmitButtonParent.parent();
            }

            form.off('submit').on('submit', () => {
                submitButton.prop('disabled', true);
                externalSubmitButton.prop('disabled', true);

                submitButtonParent.find('.spinner-border').removeClass('d-none');
                externalSubmitButtonParent.find('.spinner-border').removeClass('d-none');

                $('[data-bs-toggle="tooltip"]').tooltip("hide");

                setTimeout(() => {
                    if(submitButton.data('enable-after-post') === true) {
                        submitButton.prop('disabled', false);
                    }

                    if(externalSubmitButton.data('enable-after-post') === true) {
                        externalSubmitButton.prop('disabled', false);
                    }
                }, 500)
            })
        })
    }

    public static bindDeleteSaveButton() {

        var enableDeleteButton = $('[data-enable-delete-button]');
        var deleteContainer = enableDeleteButton.closest('.d-flex');
        var deleteButton = deleteContainer.find('[data-delete-button]');

        enableDeleteButton.off('change').on('change', () => {
            deleteButton.prop('disabled', !enableDeleteButton.is(':checked'));
        });
    }
}